module.exports = __webpack_public_path__ + "static/media/ranger_head.343032ab.svg";